import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import FilterTabs from "./routes/FilterTabs";
export default store => ({
  path: "searchv2",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "messaging" */ "./components"),
        import(
          /* webpackChunkName: "messaging" */ "MessagingV2/modules/MessagingModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        injectReducer(store, {
          key: module.NAME,
          reducer: module.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [FilterTabs(store)],
});
